import { TodoView } from "./todo";

export function App(): JSX.Element {
  return (
    <div className="page">
      <TodoView />
    </div>
  );
}
